/* 📁 ASSETS*/
import { Advertencia, Critico, PerdaComunicacao, Manutencao, NormalIcon } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, StateIndicator, VarIndicator, RefIndicator, NameContainer, ValueContainer, ValueUnit, RefContainer, RefUnit, ColumnContainer} from "./styles";

const ModalLine = ({ $background, dado, showvalue2}) => {

    return(
        <Container $background={$background}>
            
            <ColumnContainer>
                <StateIndicator src={dado.status === 4 ? Manutencao : dado.status === 3 ? PerdaComunicacao : dado.status === 2 ? 
                Critico: dado.status === 1 ? Advertencia : NormalIcon}/>

                <NameContainer>
                    {dado.name}
                </NameContainer>
            </ColumnContainer>

            <ColumnContainer>
                <VarIndicator>
                    {dado.isData === true ? '' : 'PV'}
                </VarIndicator>

                <ValueContainer $showvalue2={showvalue2} $hasUnit={dado?.unit} $isData={dado.isData}>
                    {dado.value || dado.value === 0 ? dado.value : 'SD'}  
                </ValueContainer>

                {!showvalue2 &&
                    <ValueUnit>
                        {dado.unit}
                    </ValueUnit>
                }
            </ColumnContainer>


            {showvalue2 ?
                <ColumnContainer>
                    <ValueContainer $showvalue2={showvalue2}>
                        {dado.value2 ? dado.value2 : ''}  
                    </ValueContainer>
                </ColumnContainer>
            :
                <ColumnContainer>
                    <RefIndicator>
                        {dado.SP ? 'SP' : dado.REF ? 'REF' : ''}
                    </RefIndicator>

                    <RefContainer>
                        {dado.SP ? dado.SP : dado.REF ? dado.REF : ''}
                    </RefContainer>

                    <RefUnit>
                        {dado.SP ? dado.unit : ''}
                    </RefUnit>
                </ColumnContainer>
            }

        </Container>
    )
}

export default ModalLine;